import { render, staticRenderFns } from "./PWAUpdateNotification.vue?vue&type=template&id=1648d9fc&scoped=true"
import script from "./PWAUpdateNotification.vue?vue&type=script&lang=js"
export * from "./PWAUpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./PWAUpdateNotification.vue?vue&type=style&index=0&id=1648d9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648d9fc",
  null
  
)

export default component.exports